<template>
<div id="SettlementOfClosing">
     <el-button type="info" @click="dialogFormVisible = true">结清合闸</el-button >
     <el-dialog title="电表详情" :visible.sync="dialogFormVisible">
      <el-form :model="form">
   
        <el-form-item label="尖电价(元/度):">
          <el-input v-model="form.name" ></el-input>
        </el-form-item>

        <el-form-item label="峰电价(元/度):">
          <el-input v-model="form.maxy"></el-input>
        </el-form-item>
    
        <el-form-item label="平电价(元/度):">
          <el-input v-model="form.arr"></el-input>
        </el-form-item>
      
        <el-form-item label="谷电价(元/度):">
          <el-input v-model="form.dali"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dps">确 定</el-button>
      </div>
    </el-dialog>
</div>
</template>
<script>
export default {
    name:"SettlementOfClosing",
  data() {
    return {
      dialogFormVisible: false,
      form: {
        name: "",
        arr: "",
        dali: "",
        maxy: "",
      },
      formLabelWidth: "100px",
    };
  },
  methods: {
    dps() {
      console.log(
        this.form.name,
        this.form.arr,
        this.form.dali,
        this.form.maxy,

      );
      this.dialogFormVisible = false;
    },
  },
}
</script>
<style lang="less" scoped>
#SettlementOfClosing{
    width: 100%;
    height: 100%;

  .el-form-item__content{
    .w(500) !important
  }
}

</style>